// Error actions
export const LOG_ERROR = 'LOG_ERROR'
export const LOG_ERROR_INFO = 'LOG_ERROR_INFO'
export const LOG_ERROR_INFO_SUCCESS = 'LOG_ERROR_INFO_SUCCESS'
export const LOG_ERROR_INFO_FAILED = 'LOG_ERROR_INFO_FAILED'
